export default "__VITE_ASSET__cadMrzCz__"